import React from 'react';
import { Slider, Row,Col,InputNumber,Input, Radio} from 'antd';
import './styles.css'

class CameraHeightWidget extends React.Component {

    state={
        sliderPosition: 200,
    }

    componentDidMount(){
        let handleDiv = document.createElement('div');
        handleDiv.id = "camera";
        handleDiv.innerHTML = '<img style="position: absolute;top: 1px;width:32px;height:32px;right: -12px;-moz-user-select: none;-webkit-user-select: none;user-select: none;" src="/img/camera_widget.svg"/>';
        let slider_handle = document.getElementsByClassName("ant-slider-handle")[0];
        slider_handle.style.border = "none";
        slider_handle.style.zIndex = 1000;
        slider_handle.appendChild(handleDiv);
        window.$("#slider-silo").roundSlider({
                radius: 130,    
                circleShape: "half-right",
                sliderType: "min-range",
                showTooltip: false,
                min: -90,
                startValue: 0,
                max: 90,
                value: this.props.getCameraAngle(),
                drag: (args) =>  {
                    this.props.setPolarAngle(args.value + 90);
                    this.props.setCameraAngle(args.value)
                    slider_handle.style.transform = "rotate("+args.value+"deg)";
                } 
            });
    }

    onChange = (value) => {
        this.props.setCameraHeight(value/900);
        this.setState({
            sliderPosition: value
            }
        );
    }

    render(){

        const marks = {
            0: '',
            40: '',
            80: '',
            120: '',
            160: '',
            200: ''
          };
        
        return <div id="camera_controls_container" >
                    <div style={{height:20}}></div>
                    <div className="camera_silo_container">
                        <div style={{height:20}}>
                        </div>
                        <div id="camera_silo_slider">
                            <Slider marks={marks} id="vs" vertical autoFocus tooltipVisible={false} value={200 - this.props.sliderPos} onChange={this.props.setSliderPosition} defaultValue={this.props.sliderPos} min={0} max={200} /> 
                            <div id="slider-silo" style={{top: this.state.sliderPosition}}></div>
                        </div>                       
                        <div id="slider-floor-container">
                            <div id="slider-floor-position">
                                <hr id="slider-floor"></hr>
                            </div>
                        </div>
                        {/* Camera Input Controls */}
                        <div style={{marginTop: 20, padding: '0 10px'}}>
                            <Row gutter={[8, 8]}>
                                <Col span={12}>
                                <div style={{marginBottom: 8}}>
                                        <label style={{fontSize: '12px', color: '#666'}}>Height</label>
                                        <InputNumber
                                            size="small"
                                            min={0}
                                            max={200}
                                            value={200 - this.props.sliderPos}
                                            onChange={this.props.setSliderPosition}
                                            formatter={(value) => `${Math.round(value)}`}
                                            onKeyDown={(e) => {
                                                if (
                                                  e.key === "Backspace" ||
                                                  e.key === "Delete" ||
                                                  e.key === "ArrowLeft" ||
                                                  e.key === "ArrowRight" ||
                                                  e.key === "Tab"
                                                ) {
                                                  return;
                                                }
                                                if (!/[0-9]/.test(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                            style={{width: '100%'}}
                                        />
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div style={{marginBottom: 8}}>
                                        <label style={{fontSize: '12px', color: '#666'}}>Angle</label>
                                        <InputNumber
                                            size="small"
                                            min={-90}
                                            max={90}
                                            formatter={(value) => `${value}°`}
                                            value={this.props.getCameraAngle()}
                                            onChange={(value) => {
                                                if (value !== null) {
                                                    this.props.setPolarAngle(value + 90);
                                                    this.props.setCameraAngle(value);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                  e.preventDefault();
                                                }
                                            }}
                                            style={{width: '100%'}}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
        
    }
}

export default CameraHeightWidget;